import { fetchQuery } from 'relay-runtime';
import graphql from 'babel-plugin-relay/macro';
import { getEnvironment } from '../../../../shared/utils/helpers';

const query = graphql`
  query CheckContractSigningPermissionMutation($contractTemplateId: ID!, $contractValue: Decimal!) {
    checkContractSigningPermission(contractTemplateId: $contractTemplateId, contractValue: $contractValue) {
      canSign
      reason
    }
  }
`;

export default (contractTemplateId, contractValue, callback) => {
  const variables = {
    contractTemplateId,
    contractValue
  };

  fetchQuery(getEnvironment(), query, variables)
    .then(response => {
      callback(response, null);
    })
    .catch(err => {
      console.error(err);
      callback(null, err);
    });
};
